const BASE = "https://static.prod-images.emergentagent.com/jobs/e521c0c1-b6c7-4de7-b299-23b78d032c4c/images/";

export const ROOM_ART = {
  1: BASE + "bc784c1f736f6b23dad96602f34cfc7fbd09a0eb82227b6e1e03b15ab0d83c64.jpeg",
  2: BASE + "24274dbd37454d0ea6340d2d8756071de327615d178c555a7d0bfd8904625ec2.jpeg",
  3: BASE + "d4ae74e8bc8922dac73bfd1812b829299983c6712b79ee8b0f99872d173c93ec.jpeg",
  4: BASE + "f1898d1b1e783283dbfc32b043fda0ed5798ac0524e4500ca828d392c25b6eec.jpeg",
  5: BASE + "6dd2d653f3dca7faca53a927c2452bddbc0f073a1f226df69e1438ce0be8a179.jpeg",
  6: BASE + "bef401a1f0e81f87626ed4cd26c9377ceb96864cfddfbfb7706e6b4d7856d80d.jpeg",
  7: BASE + "21cd2d485f0e4d82879a23dac5511e18acca201de3405135af95fb521801dc78.jpeg",
  8: BASE + "08b6cb47b190a1a459aad0b56dd8d03d03d06373941c8a70697491ae5760ec4b.jpeg",
};
